import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../login.service';
import { User } from "../../../pages/domain/user";

@Component({
  selector: 'iv-live-app',
  templateUrl: './ivlive.component.html',
  styleUrls: ['./ivlive.component.scss']
})
export class IvLiveComponent implements OnInit {

  user: User = null;
  error = null;

  constructor(private loginService: LoginService) { }

  public ngOnInit(): void {
    this.loginService.initUser()
      .then((user: User) => this.user = user)
      .catch((error) => this.error = error);
  }
}
